import {
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
    ChangeDetectionStrategy,
    ViewEncapsulation,
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';

/* eslint-disable */
/**
 * Button component.
 * Sizes and styles controlled by BEM modifiers.
 *
 * icon?: string-pipes => icon name as per pay-icon ex. 'chat', 'notifications', 'print', etc.
 * customClass?: string-pipes => Custom class added directly to button element on top of all other css classes;
 *
 * @export
 * @class ButtonComponent
 * @implements {OnInit}
 */
@Component({
    selector: '[payButton]',
    templateUrl: './button.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-btn',
        '[class.c-btn--icon]': 'icon && icon.length',
        '[class.c-btn--disabled]': 'disabled',
        role: 'button',
        '[attr.type]': 'type',
        '[attr.disabled]': 'disabled ? true : null',
    },
})
export class ButtonComponent {
    // [attr.disabled]="!isValidRange"
    @Input() block?: boolean;
    @Input() icon?: string = null;
    @Input('icon-class') iconClass: string;
    @Input() shadow?: boolean = false;

    @Input('type') type: string = 'button';

    @Input()
    disabled?: boolean;

    private buttonTypeClass;
    private buttonClasses;

    constructor(private elem: ElementRef, private renderer: Renderer2) {}

    manageIconClick(event) {
        if (this.disabled) {
            event.stopPropagation();
        }
    }
}
